import { Fragment, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import AccountMenuContent from '@/components/app-shell/AccountMenuContent';
import ShellAccountMenuTrigger from '@/components/app-shell/ShellAccountMenuTrigger';
import ShellLogoutButton from '@/components/app-shell/ShellLogoutButton';
import MobileDrawerPanel from '@/components/shared/MobileDrawerPanel';
import { Drawer } from '@/components/ui/daisy/drawer';
import useToggle from '@/data/hook/useToggle';

type AccountDrawerProps = PropsWithChildren<{
  className?: string;
}>;

export default function AccountDrawer({
  className,
  children,
}: AccountDrawerProps) {
  const { isOpen, open, close } = useToggle();
  const { t } = useTranslation('translation', {
    keyPrefix: 'appShell.account',
  });

  return (
    <Fragment>
      <ShellAccountMenuTrigger
        isOpen={isOpen}
        onClick={open}
        className={className}
      >
        {children}
      </ShellAccountMenuTrigger>
      <Drawer
        open={isOpen}
        onOpenChange={close}
        position="end"
        className="absolute size-0"
      >
        <Drawer.Side components={{ overlay: { 'aria-label': t('close') } }}>
          <MobileDrawerPanel
            aria-label={t('label')}
            closeLabel={t('close')}
            onClose={close}
          >
            <AccountMenuContent
              onNavigate={close}
              itemClassName="bg-base-200 font-medium"
            />
            <ShellLogoutButton />
          </MobileDrawerPanel>
        </Drawer.Side>
      </Drawer>
    </Fragment>
  );
}
